var _defs, _use, _use2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArvolutionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "37px",
    height: "40px",
    viewBox: "0 0 37 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.326099%",
    y1: "-4.34759963%",
    x2: "39.5866506%",
    y2: "88.8283944%",
    id: "arvolution-logo-gradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8544E8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C75DA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "9.75583903%",
    y1: "80.4518891%",
    x2: "31.7483401%",
    y2: "67.2483948%",
    id: "arvolution-logo-gradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8544E8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C75DA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.3909063%",
    y1: "5.36151909%",
    x2: "82.5299648%",
    y2: "26.6015543%",
    id: "arvolution-logo-gradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6115D5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C75DA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.8899407,2.32890632 L29.3949402,9.90781361 L29.3949402,25.1935925 C29.3949402,26.0761491 29.1631747,26.9426094 28.7237183,27.70297 L25.7072677,32.922123 L6.44055441,31.392547 C3.77122387,31.18063 1.77579782,28.8025523 1.98364559,26.0809618 C2.05411415,25.1582357 2.377261,24.2742182 2.91629877,23.5295469 L18.2591722,2.33363341 C19.4074316,0.747332982 21.5995376,0.410454643 23.1553779,1.58119458 C23.4353083,1.79183685 23.6828825,2.04384271 23.8899407,2.32890632 Z",
    id: "arvolution-logo-path-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.5143991%",
    y1: "11.2618379%",
    x2: "93.6361888%",
    y2: "50%",
    id: "arvolution-logo-gradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EDAED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4241F1",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Web->-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Welcome-Email",
    transform: "translate(-40.000000, -84.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Div---Form",
    transform: "translate(39.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arvolution-logo",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Triangle"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#arvolution-logo-gradient-1)",
    xlinkHref: "#arvolution-logo-path-4"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#arvolution-logo-gradient-2)",
    xlinkHref: "#arvolution-logo-path-4"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.3,
    fill: "url(#arvolution-logo-gradient-3)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#arvolution-logo-path-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.07777563,22.958323 L12.3012686,26.3373511 C13.2657882,27.1090202 13.4221244,28.5164792 12.6504554,29.4809988 C12.1930948,30.05266 11.4849092,30.3642925 10.7544452,30.3153257 L9.90471253,30.2583637 L6.8299202,29.9203719 C5.69319941,29.7954197 4.6711471,29.1707976 4.04145153,28.2162136 L3.85534562,27.9340872 C3.34477749,27.1600938 3.21440381,26.195739 3.50112346,25.3139582 L3.50112346,25.3139582 C3.79611685,24.4067322 4.36882225,23.6151855 5.13826409,23.0512358 L5.34390802,22.9005124 C6.16355294,22.2997672 7.28425888,22.3234657 8.07777563,22.958323 Z",
    id: "Triangle",
    fill: "url(#arvolution-logo-gradient-1)",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.398876
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9199971,4.22212723 L28.3580683,36.1349748 C27.7391918,38.746757 25.1202255,40.3623263 22.5084433,39.7434498 C21.629814,39.5352536 20.8265592,39.0863968 20.188762,38.4472177 L1.33528341,19.5528864 C-0.560609551,17.6528853 -0.557279264,14.5757052 1.34272182,12.6798122 C1.80705648,12.2164815 2.36038038,11.8519437 2.96935677,11.6081615 L31.3211295,0.258528757 C33.0746588,-0.443434887 35.0652292,0.409027522 35.7671928,2.16255684 C36.0291483,2.81693065 36.082517,3.5362606 35.9199971,4.22212723 Z",
    id: "Triangle",
    fill: "url(#arvolution-logo-gradient-5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2402141,8.2000908 L29.2848064,9.22712975 C31.9569556,9.39817812 33.987161,11.745455 33.8193971,14.4699194 C33.7847196,15.0330783 33.6557197,15.5860251 33.4379896,16.1047902 L25.3309531,35.4206613 C24.2776128,37.9303561 21.4282687,39.094247 18.966765,38.0202843 C17.8568288,37.5360153 16.9640552,36.6469147 16.463125,35.5269446 L7.82710333,16.218693 C6.55161183,13.3669736 7.78500633,10.0009647 10.5819671,8.70050168 C11.4142577,8.31352334 12.3272635,8.14165143 13.2402141,8.2000908 Z",
    id: "Triangle",
    fill: "#E4EBFA",
    opacity: 0.438895089
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArvolutionLogo);
export default __webpack_public_path__ + "static/media/arvolution-logo.808978ac0c28110e0cc58d4fbf9245f3.svg";
export { ForwardRef as ReactComponent };